"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADD_NEW_SEGMENT = void 0;
const pages_1 = require("@/pages");
const models_hook_1 = require("app/models.hook");
const react_1 = __importStar(require("react"));
const react_hook_form_1 = require("react-hook-form");
const standard_1 = require("react-hook-schema/standard");
const react_router_dom_1 = require("react-router-dom");
const components_1 = require("utils/components");
const route_1 = require("../route");
const DataLink_1 = __importDefault(require("./DataLink"));
const UploadFile_1 = require("./UploadFile");
const green_check_svg_1 = __importDefault(require("assets/green-check.svg"));
const warning_svg_1 = __importDefault(require("assets/warning.svg"));
exports.ADD_NEW_SEGMENT = route_1.SEGMENTS.sub("/create", SegmentCreate);
const steps = [
    {
        title: "ファイルアップロード",
    },
    {
        title: "データ紐づけ",
    },
    {
        title: "新規ファイル作成完了",
    },
];
function SegmentCreate({ projectId, segmentId, }) {
    var _a;
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [currentStep, setCurrentStep] = react_1.default.useState(0);
    const [errors, setErrors] = react_1.default.useState([]);
    const [createdSegmentIds, setCreatedSegmentIds] = react_1.default.useState([]);
    const [uploadErrorList, setUploadErrorList] = (0, react_1.useState)([]);
    const { data: projectData, loading: projectDataLoading } = (0, models_hook_1.useProjectDoc)({
        projectId,
    });
    const form = (0, react_hook_form_1.useForm)({
        defaultValues: {
            createdAt: Date.now(),
            columnsToSave: projectData.columnsToSave,
            headerRowNumber: 1,
            scriptIdFormat: "{row_no}-{sheet_name}",
            originalScriptField: "text_ja",
            translatedScriptFieldFormat: "text_{locale}",
            uploadMode: "worksheet",
        },
        mode: "all",
    });
    const handleNext = ({ error }) => {
        if (error) {
            setErrors([error]);
            return;
        }
        setErrors([]);
        setCurrentStep((prev) => prev + 1);
    };
    const getErrorForFile = (fileName) => {
        return uploadErrorList.find((error) => error.fileName === fileName);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(components_1.PageHeader, { title: "\u7FFB\u8A33\u30D5\u30A1\u30A4\u30EB\u65B0\u898F\u4F5C\u6210", breadCrumbConfigs: [
                {
                    name: "プロジェクト一覧",
                    path: (0, pages_1.resolveRoute)("LIST_PROJECTS"),
                },
                {
                    name: "翻訳ファイル一覧",
                    path: (0, pages_1.resolveRoute)("LIST_SEGMENTS", { projectId }),
                },
                {
                    name: "翻訳ファイル新規作成",
                },
            ] }),
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: "stepper-container" }, steps.map((step, index) => (react_1.default.createElement("div", { key: index, className: `step-label ${index === currentStep ? "active" : ""} ${index < currentStep ? "completed" : ""}` },
                react_1.default.createElement("div", { className: "step-number" }, index + 1),
                react_1.default.createElement("div", { className: "step-title" }, step.title))))),
            react_1.default.createElement("div", { style: { padding: "20px 28px" } },
                errors &&
                    (errors === null || errors === void 0 ? void 0 : errors.map((error) => (react_1.default.createElement("p", { className: "text-danger fw-bold text-center p-3" }, error)))),
                react_1.default.createElement(react_hook_form_1.FormProvider, Object.assign({}, form),
                    react_1.default.createElement("form", null,
                        currentStep === 0 && (react_1.default.createElement("div", { 
                            // hidden={currentStep !== 0}
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                gap: "12px",
                            } },
                            react_1.default.createElement(components_1.Card, { title: "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u30E2\u30FC\u30C9\u306E\u9078\u629E", tooltip: "\u53C2\u7167\u30E2\u30FC\u30C9\u306F\u3001\u3059\u3067\u306B\u5B8C\u4E86\u3057\u305F\u7FFB\u8A33\u3092\u4ECA\u5F8C\u306E\u7FFB\u8A33\u306B\u5229\u7528\u3059\u308B\u5834\u5408\u306B\u4F7F\u7528\u3057\u307E\u3059\u3002\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u305F\u30D5\u30A1\u30A4\u30EB\u306E\u7FFB\u8A33\u4F5C\u696D\u3092\u9032\u3081\u305F\u3044\u5834\u5408\u306F\u3001\u53C2\u7167\u30E2\u30FC\u30C9\u3067\u306F\u306A\u304F\u3001\u30EF\u30FC\u30AF\u30B7\u30FC\u30C8\u30E2\u30FC\u30C9\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002", required: true },
                                react_1.default.createElement("div", { style: { padding: "12px 20px" } },
                                    react_1.default.createElement(standard_1.radio, { control: form.control, fieldPath: "uploadMode", schema: {
                                            schemaType: "radio",
                                            options: [
                                                { label: "ワークシート", value: "worksheet" },
                                                { label: "参照", value: "reference" },
                                            ],
                                            defaultValue: "worksheet",
                                            required: true,
                                            horizontal: true,
                                        } }))),
                            react_1.default.createElement(UploadFile_1.UploadFile, { projectId: projectId, onNext: handleNext, onErrors: (errors) => setErrors(errors) }))),
                        currentStep === 1 && (react_1.default.createElement(DataLink_1.default, { segmentId: segmentId, projectId: projectId, onNext: handleNext, onBack: () => setCurrentStep(0), uploadErrorList: uploadErrorList, setUploadErrorList: setUploadErrorList, setCreatedSegmentIds: setCreatedSegmentIds })))),
                currentStep === 2 && (react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 16 } }, ((_a = form.watch("rawFiles")) !== null && _a !== void 0 ? _a : []).map((file) => {
                        var _a;
                        const error = getErrorForFile(((_a = file === null || file === void 0 ? void 0 : file.file) === null || _a === void 0 ? void 0 : _a.name) || (file === null || file === void 0 ? void 0 : file.fileName));
                        return (react_1.default.createElement(components_1.Card, { title: "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u7D50\u679C", key: file.fileName },
                            react_1.default.createElement("div", { className: "d-flex align-items-start" },
                                react_1.default.createElement("div", { className: "flex-grow-1" },
                                    react_1.default.createElement("div", { style: {
                                            padding: 20,
                                            borderBottom: "1px solid #D4D4D4",
                                        } },
                                        react_1.default.createElement("p", { style: { fontSize: 14 } }, file.fileName)),
                                    react_1.default.createElement("div", { style: { padding: 20 } }, error ? (react_1.default.createElement("div", { className: "" },
                                        react_1.default.createElement("span", { className: "fw-bold text-danger d-flex gap-2 align-items-center" },
                                            react_1.default.createElement("p", null, error.message),
                                            react_1.default.createElement("img", { src: warning_svg_1.default })),
                                        error.row && (react_1.default.createElement("small", { className: "text-muted d-block mt-1" },
                                            "\u884C: ",
                                            error.row)))) : (react_1.default.createElement("div", { className: "text-success d-flex gap-2 align-items-center" },
                                        react_1.default.createElement("p", { style: { fontWeight: 600 } }, "\u6B63\u5E38\u306B\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3055\u308C\u307E\u3057\u305F"),
                                        react_1.default.createElement("img", { src: green_check_svg_1.default }))))))));
                    })),
                    react_1.default.createElement("section", { className: "d-flex justify-content-center align-items-center mt-4 gap-2" },
                        react_1.default.createElement(components_1.Button, { size: "xl", onClick: () => {
                                if (createdSegmentIds && createdSegmentIds.length === 1) {
                                    navigate((0, pages_1.resolveRoute)("LIST_SEGMENT_SCRIPTS", {
                                        projectId,
                                        segmentId: createdSegmentIds[0],
                                    }));
                                }
                                else {
                                    navigate((0, pages_1.resolveRoute)("LIST_SEGMENTS", {
                                        projectId,
                                    }));
                                }
                            } }, "\u7FFB\u8A33\u4F5C\u696D\u3092\u958B\u59CB\u3059\u308B"),
                        react_1.default.createElement(components_1.Button, { size: "xl", onClick: () => {
                                navigate(0);
                            } }, "\u5F15\u304D\u7D9A\u304D\u30D5\u30A1\u30A4\u30EB\u3092\u65B0\u898F\u4F5C\u6210"))))))));
}
exports.default = SegmentCreate;
